export const renderArrayObjectValueWithComas = (array, valueLabel) => {
  return array.map(({ [valueLabel]: value }) => value).join(', ')
}
